<template src="./RiskMessageCard.html"></template>

<script>
import RiskBadge from "@/components/DataAnalysis/Risk/RiskBadge/RiskBadge.vue";

export default {
  name: "RiskMessageCard",
  components: { RiskBadge },
  props: {
    variant: { type: String, required: true },
    presentation: { type: Object, default: null },
    error: { type: Object, default: null },
    startDate: { type: String, default: null },
    endDate: { type: String, default: null },
    // A marker is on the map but LOAD DATA has not been pressed for it yet, so this tab
    // has nothing to show for it. Distinct from having no marker at all.
    pinPending: { type: Boolean, default: false },
  },
  computed: {
    coverageSuffix() {
      if (this.presentation && this.presentation.coverage === "global") return "";
      return " · CONUS only (PRISM 4 km grid)";
    },
    emptyBody() {
      if (this.pinPending) {
        return "The marker has moved. Press LOAD DATA in the panel header to compute the historical probability for this location.";
      }
      return this.presentation && this.presentation.emptyBody;
    },
    emptyCaption() {
      return (this.pinPending ? "Awaiting LOAD DATA" : "Awaiting location") + this.coverageSuffix;
    },
    coordsText() {
      const details = this.error && this.error.details;
      if (!details || details.lat == null) return "";
      return `${details.lat}, ${details.lon}`;
    },
    noDataTitle() {
      const fromPresentation = this.presentation && this.presentation.noDataTitle;
      return fromPresentation || "No records returned for this period";
    },
    notImplementedTitle() {
      const label = this.presentation ? this.presentation.label : "This indicator";
      return `${label} isn't computed yet`;
    },
  },
};
</script>

<style lang="scss" src="./RiskMessageCard.scss"></style>
